import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import AppShell from "./AppShell";

export default function FixGenerator() {
  const [fixes, setFixes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/fixes").then((r) => {
      setFixes(r.data);
      setLoading(false);
    });
  }, []);

  const copy = (text) => {
    navigator.clipboard.writeText(text || "");
    toast.success("Copied");
  };

  return (
    <AppShell title="Fix library" subtitle="// generated fixes">
      <div data-testid="fix-library-page">
        {loading ? (
          <div className="font-mono text-sm">Loading…</div>
        ) : fixes.length === 0 ? (
          <div className="border border-dashed border-border p-12 text-center bg-card">
            <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">// empty</div>
            <h2 className="mt-2 font-marketing text-3xl">No fixes generated yet.</h2>
            <p className="mt-3 text-muted-foreground">Open an audit → recommendations → tap <em>Generate fix</em>.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {fixes.map((f) => (
              <div key={f.id} className="border border-border bg-card" data-testid={`fix-${f.id}`}>
                <div className="flex justify-between items-center px-6 py-3 border-b border-border">
                  <div>
                    <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">// {f.fix_type} · {f.created_at?.slice(0, 16).replace("T", " ")}</div>
                    <div className="font-app text-lg">{f.title}</div>
                  </div>
                  <button onClick={() => copy(f.content)} data-testid={`copy-fix-${f.id}`} className="px-3 py-1.5 border border-border font-mono text-xs uppercase tracking-widest hover:bg-obsidian hover:text-bone transition-colors">Copy</button>
                </div>
                <pre className="p-6 terminal text-sm whitespace-pre-wrap overflow-x-auto max-h-[400px]">{f.content}</pre>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
